export default function AnimatedGiftBox({ size = 'md', className = '' }) {
  const px = size === 'xs' ? 30 : size === 'sm' ? 44 : size === 'lg' ? 78 : 62;

  return (
    <span
      className={`vl-giftbox ${className}`}
      style={{ width: px, height: px }}
      aria-hidden="true"
    >
      <span className="vl-giftbox-spark vl-giftbox-spark-a" />
      <span className="vl-giftbox-spark vl-giftbox-spark-b" />
      <span className="vl-giftbox-lid" />
      <span className="vl-giftbox-bow vl-giftbox-bow-left" />
      <span className="vl-giftbox-bow vl-giftbox-bow-right" />
      <span className="vl-giftbox-body" />
      <span className="vl-giftbox-ribbon-v" />
      <span className="vl-giftbox-ribbon-h" />
      <style>{`
        .vl-giftbox {
          position: relative;
          display: inline-block;
          filter: drop-shadow(0 12px 22px rgba(34,197,94,0.28));
          animation: vlGiftBounce 1.9s ease-in-out infinite;
        }
        .vl-giftbox-body,
        .vl-giftbox-lid {
          position: absolute;
          left: 13%;
          right: 13%;
          border-radius: 14%;
          background: linear-gradient(135deg, #21e56f 0%, #0aaa4b 48%, #026d31 100%);
          border: 1px solid rgba(255,255,255,0.2);
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.35);
        }
        .vl-giftbox-body {
          bottom: 8%;
          height: 47%;
        }
        .vl-giftbox-lid {
          top: 28%;
          height: 20%;
          transform-origin: 50% 100%;
          animation: vlGiftLid 1.9s ease-in-out infinite;
        }
        .vl-giftbox-ribbon-v,
        .vl-giftbox-ribbon-h {
          position: absolute;
          z-index: 2;
          background: linear-gradient(180deg, #ffe680, #f1b91f);
          border-radius: 999px;
        }
        .vl-giftbox-ribbon-v {
          top: 28%;
          bottom: 8%;
          width: 14%;
          left: 43%;
        }
        .vl-giftbox-ribbon-h {
          left: 13%;
          right: 13%;
          top: 51%;
          height: 12%;
        }
        .vl-giftbox-bow {
          position: absolute;
          top: 10%;
          width: 31%;
          height: 25%;
          border: 5px solid #ffe680;
          border-radius: 999px 999px 20px 999px;
          z-index: 3;
          background: rgba(255,230,128,0.08);
        }
        .vl-giftbox-bow-left {
          left: 17%;
          transform: rotate(-24deg);
        }
        .vl-giftbox-bow-right {
          right: 17%;
          transform: scaleX(-1) rotate(-24deg);
        }
        .vl-giftbox-spark {
          position: absolute;
          width: 11%;
          height: 11%;
          border-radius: 999px;
          background: #f5d76e;
          box-shadow: 0 0 14px rgba(245,215,110,0.85);
          animation: vlGiftSpark 1.9s ease-in-out infinite;
        }
        .vl-giftbox-spark-a { top: 4%; left: 4%; }
        .vl-giftbox-spark-b { top: 2%; right: 6%; animation-delay: .35s; }
        @keyframes vlGiftBounce {
          0%, 100% { transform: translateY(0) rotate(-1deg); }
          50% { transform: translateY(-5px) rotate(1deg); }
        }
        @keyframes vlGiftLid {
          0%, 100% { transform: translateY(0) rotate(0); }
          45% { transform: translateY(-4px) rotate(-3deg); }
          65% { transform: translateY(-2px) rotate(2deg); }
        }
        @keyframes vlGiftSpark {
          0%, 100% { opacity: .35; transform: scale(.75); }
          50% { opacity: 1; transform: scale(1.2); }
        }
      `}</style>
    </span>
  );
}
